module.exports = __webpack_public_path__ + "static/media/block1资讯中心背景.f7e77404.png";